import { usePriceList } from '@zenbusiness/application-commons-pricelist';

// There are some products that uses different service codes for monthly and annual plans, that leads to a bug since the service name is the same for both but we need to filter by interval. i.e: There is only zb_money_pro, zb_money_pro_month and zb_money_pro_year does not exist on the current price list.
const productsWithIntervalMap = {
  zb_money_pro_month: 'zb_money_pro',
  zb_money_pro_year: 'zb_money_pro'
};

export const useProductPrice = (service, interval, enabledCoupon = null) => {
  const { priceListUuid, get } = usePriceList();

  if (!priceListUuid) {
    return { amount: 0, interval: null };
  }

  const serviceNameToUse = productsWithIntervalMap[service] || service;

  // If interval is provided, use it; otherwise try to get product without interval filter
  // (price list may have one-time products that don't match 'annual' default)
  let product = interval ? get(serviceNameToUse, { interval }) : get(serviceNameToUse);

  // If no product found and no interval was provided, try common intervals as fallback
  if (!product && !interval) {
    product = get(serviceNameToUse, { interval: 'annual' })
      || get(serviceNameToUse, { interval: 'onetime' })
      || get(serviceNameToUse, { interval: 'monthly' });
  }

  if (!product) {
    return { amount: 0, interval: null };
  }

  // Original pricing values
  const originalAmount = product.pricing?.price || 0;
  const productInterval = product?.pricing?.interval || null;
  const fees = product?.pricing?.fees || null;

  // Coupon calculation (only if coupon is provided)
  let finalAmount = originalAmount;
  if (enabledCoupon?.amount) {
    finalAmount = Math.max(originalAmount - enabledCoupon.amount, 0);
  }

  return {
    amount: finalAmount,
    enabledCoupon,
    fees,
    interval: productInterval,
    originalAmount
  };
};
